import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  documentTypes = [],
  clients = [], // ✅ NEW
  leasingPartners = [], // ✅ NEW
}) {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [client, setClient] = useState(""); // ✅ NEW
  const [leasingPartner, setLeasingPartner] = useState(""); // ✅ NEW

  const handleApply = () => {
    applyFilters({
      month,
      year,
      documentType,
      client,
      leasingPartner,
    });
    onHide();
  };

  const handleClear = () => {
    setMonth("");
    setYear("");
    setDocumentType("");
    setClient("");
    setLeasingPartner("");
    removeFilters();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Filter Documents Data</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* ✅ DOCUMENT TYPE */}
          <Form.Group className="mb-3">
            <Form.Label>Select Document Type</Form.Label>
            <Form.Select
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            >
              <option value="">-- All Document Types --</option>
              {documentTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* ✅ ✅ CLIENT FILTER */}
          <Form.Group className="mb-3">
            <Form.Label>Select Client</Form.Label>
            <Form.Select
              value={client}
              onChange={(e) => setClient(e.target.value)}
            >
              <option value="">-- All Clients --</option>
              {clients.length > 0 ? (
                clients.map((c, index) => (
                  <option key={index} value={c}>
                    {c}
                  </option>
                ))
              ) : (
                <option disabled>No Clients Found</option>
              )}
            </Form.Select>
          </Form.Group>

          {/* ✅ ✅ LEASING PARTNER FILTER */}
          <Form.Group className="mb-3">
            <Form.Label>Select Leasing Partner</Form.Label>
            <Form.Select
              value={leasingPartner}
              onChange={(e) => setLeasingPartner(e.target.value)}
            >
              <option value="">-- All Leasing Partners --</option>
              {leasingPartners.length > 0 ? (
                leasingPartners.map((lp, index) => (
                  <option key={index} value={lp}>
                    {lp}
                  </option>
                ))
              ) : (
                <option disabled>No Leasing Partners Found</option>
              )}
            </Form.Select>
          </Form.Group>

          {/* ✅ MONTH FILTER */}
          <Form.Group className="mb-3">
            <Form.Label>Select Month</Form.Label>
            <Form.Select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option value="">-- Select Month --</option>
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((m, i) => (
                <option key={i} value={i + 1}>
                  {m}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* ✅ YEAR FILTER */}
          <Form.Group className="mb-3">
            <Form.Label>Select Year</Form.Label>
            <Form.Control
              type="number"
              placeholder="e.g. 2025"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
